import React from 'react';
import PropTypes from 'prop-types';

// styles
import css from './icon.sss';


export const Icon = ({ className, glyph: { id, viewBox } }) => (
    <svg className={className || css.root} viewBox={viewBox}>
        <use xlinkHref={`#${id}`} />
    </svg>
);

Icon.propTypes = {
    className: PropTypes.string,
    glyph: PropTypes.shape({
        id: PropTypes.string.isRequired,
        viewBox: PropTypes.string.isRequired,
    }).isRequired,
};
